// PrivateRoute3.js
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";


const PrivateRoute3 = () => {
  const user = useSelector((state) => state.user.user)

  if (user.CoreLabId === 1 || window.innerWidth < 480) {
    return <Navigate to='/dashboard' />;
  }
  return <Outlet />;
};

export default PrivateRoute3;
